import { FieldTypes } from '../types';
import {
  dateOperators,
  dateRangeOperators,
  globalOperators,
  stringOperators,
  textOperators,
} from '../types/operatorTypes';

const source = 'yaraRule';

export const getYaraRuleFields = (): FieldTypes[] => [
  {
    label: 'Name',
    prop: 'name',
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source: source,
  },
  {
    label: 'Enabled',
    prop: 'enabled',
    operators: [...globalOperators],
    type: 'list',
    source,
    options: [
      {
        label: 'True',
        prop: 'true',
      },
      {
        label: 'False',
        prop: 'false',
      },
    ],
  },
  {
    label: 'Description',
    prop: 'description',
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Created',
    prop: 'created',
    operators: [
      ...globalOperators,
      ...dateRangeOperators.filter((d) => d.type !== 'next'),
      ...dateOperators,
    ],
    type: 'date',
    source,
    disableFuture: true,
  },
];
